import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-pagination',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './pagination.component.html'
})
export class PaginationComponent implements OnInit, OnChanges {
  @Input() data: any[] = [];
  @Input() pageSize: number = 10;
  @Output() paginatedData = new EventEmitter<any[]>();
  @Output() pageSizeChange = new EventEmitter<number>();

  currentPage: number = 1;
  totalPages: number = 1;
  pages: number[] = [];
  
  pageSizeOptions: number[] = [ 5, 10, 25, 50, 100];
  
  startItem: number = 0;
  endItem: number = 0;
  
  constructor() {}

  ngOnInit() {
    if (!this.pageSizeOptions.includes(this.pageSize)) {
      this.pageSizeOptions.push(this.pageSize);
      this.pageSizeOptions.sort((a, b) => a - b);
    }
    this.initPagination();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data'] || changes['pageSize']) {
      this.currentPage = 1;
      this.initPagination();
    }
  }

  private initPagination() {
    if (!this.data || this.data.length === 0) {
      this.totalPages = 1;
      this.pages = [1];
      this.startItem = 0;
      this.endItem = 0;
      this.paginatedData.emit([]);
      return;
    }
    
    this.totalPages = Math.ceil(this.data.length / this.pageSize);
    this.pages = Array.from({ length: this.totalPages }, (_, i) => i + 1);
    this.emitPage();
  }

  goToPage(page: number) {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    this.emitPage();
  }

  onPageSizeChange(newSize: number) {
    this.pageSize = newSize;
    this.pageSizeChange.emit(newSize);
    this.currentPage = 1;
    this.initPagination();
  }

  private emitPage() {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    
    this.startItem = this.data.length > 0 ? start + 1 : 0;
    this.endItem = Math.min(end, this.data.length);
    
    const pagedData = this.data.slice(start, end);
    this.paginatedData.emit(pagedData);
  }
} 